import React, { createRef, forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { Form, Modal } from "reactstrap";
import Swal from 'sweetalert2';
import { Controller, useForm } from "react-hook-form";

import API from '../../API';
import { DateFormat, DateFormatJSON, DateThai, MobileFormat, NumberFormat, CleanMobile, TimeFormat, APIURL, GetAuthorization, KeyDownNumber } from '../../Utils/Function';
import { SearchSubDistrict, SearchCustomer } from '../../Utils/Search';
import parse from 'html-react-parser'
import moment from 'moment';
import AsyncSelect from 'react-select/async';
import { UploadCard, DeleteFile, FilePreviewCard } from '../../Components'

const VendorInfo = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();

    const [ModalState, setModalState] = useState(false);
    const [_Detail, setDetail] = useState(null);
    const _UploadRef = useRef();
    const [_FileList, setFileList] = useState([]);
    const _FilePreviewRef = useRef();
    useEffect(() => {
        (async () => {

        })();

        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
        Show(VendorID) {
            _ClearValuAction();
            setDetail(null);
            _Initial();
            if (VendorID === undefined) {
                setModalState(true);
            } else {
                _LoadDetail(VendorID);
            }
        }
    }));
    const _Initial = () => {

    }
    const _LoadDetail = async (VendorID) => {
        setFileList([]);
        API({ method: "get", url: "/Vendor/" + VendorID }).then(res => {
            if (res.status !== 200) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
                return;
            }

            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
                return;
            }
            const _Res = res.data.Data;
            setDetail(res.data.Data);
            setValue('VendorName', _Res.VendorName);
            setValue('Remark', _Res.Remark);

            //_UploadGetFileLsit(res.data.Data.ProductId)
            setModalState(true);
        }).catch(res => {
            if (res.response.data != undefined) {
                Swal.fire({
                    icon: 'error',
                    title: res.code,
                    text: res.response.data.Message
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'การเชื่อมต่อผิดพลาด',
                    text: res.message + ' [' + res.code + ']',
                });
            }
            return;
        });
    }

    const _Save = async () => {

        if (getValues('VendorName') == undefined || getValues('VendorName') === "") {
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ ชื่อคู่ค้า'
            });
            return;
        }


        let _reqObj = {
            vendorID   : (_Detail != null ? _Detail.VendorID : null),
            vendorName : getValues('VendorName'),
            status     : (_Detail != null ? (_Detail.Status ?? _Detail.status ?? 1) : 1),
            remark     : getValues('Remark'),
        }

        Swal.fire({
            icon: 'warning',
            title: 'ต้องการบันทึก หรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'บันทึก',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {

            if (!r.isConfirmed) {
                return;
            }

            API({ method: 'post', url: '/Vendor/Save', data: _reqObj }).then(res => {
                if (!res.data.Status) {
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });

                    return;
                }
                setModalState(false);
                _ClearValuAction();
                if (props.update != undefined) {
                    try {
                        props.update(res.data.Data);
                    } catch (e) {
                        console.log(e);
                    }
                }
                if (props.Reload != undefined) {
                    try {
                        props.Reload();
                    } catch (e) {
                        console.log(e);
                    }
                }
            }).catch(res => {
                if (res.response.data != undefined) {
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message + ' [' + res.code + ']',
                    });
                }
            });

        });

    }

    const _ClearValuAction = () => {
        reset();
    }
    const _ClearValue = () => {
        Swal.fire({
            icon: 'warning',
            title: 'ต้องการล้างข้อมูล หรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) {
                return;
            }
            _ClearValuAction();
        });
    }
    return (
        <>
            <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
                <div className="modal-header">
                    <h5 className="modal-title">{(_Detail != null ? "แก้ไขคู่ค้า" : "สร้างคู่ค้า")}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setModalState(false) }}></button>
                </div>
                <div className='modal-body' style={{ 'minHeight': '300px' }}>
                    <Form onSubmit={handleSubmit(_Save)} className='row g-3'>
                        <div className='row mt-4'>
                            <div className="col-md-6">
                                <label className="form-label">ชื่อคู่ค้า</label>
                                <input type='text' className="form-control text-left" placeholder="ชื่อคู่ค้า" autoComplete="off"   {...register("VendorName", { required: false })} />
                            </div>
                        </div>

                        <div className='row mt-3'>
                            <div className="col-md-12">
                                <label className="form-label">หมายเหตุ</label>
                                <Controller name="Remark" control={control} rules={{ required: false }} render={({ field }) => (
                                    <textarea className="form-control" autoComplete="off" onChange={(e) => field.onChange(e)} defaultValue={field.value} />
                                )} />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-md-12 mt-4 text-end'>
                                <div className='btn-group btn-group-lg'>
                                    {/* <button type="button" className='btn btn-danger' disabled={(_Detail != null ? true : false)} onClick={() => { _ClearValue(); }}>ล้างข้อมูล</button> */}
                                    <button type="submit" className='btn btn-success'>บันทึก</button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal>
        </>
    )
});
export default React.memo(VendorInfo);